import { render, staticRenderFns } from "./CreateSegments.vue?vue&type=template&id=1eef3800&scoped=true"
import script from "./CreateSegments.vue?vue&type=script&lang=js"
export * from "./CreateSegments.vue?vue&type=script&lang=js"
import style0 from "./CreateSegments.vue?vue&type=style&index=0&id=1eef3800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eef3800",
  null
  
)

export default component.exports